import type { Tab } from '../../custom-tab-bar/type.d.ts';

import { reportTypes } from './lib.ts';

export const route = {
  component: () => import('./page.vue'),
  path: '/arrhythmia/history/:reportType(unassigned|single|weekly)?',
  alias: [
    '/reports/:reportType(unassigned|single|weekly)?',
    '/records/:reportType(unassigned|single|weekly)?',
  ],
  name: 'arrhythmia-history',
  meta: {
    title: '报告',
    titleMaps: reportTypes,
    titleKey: 'reportType',
    auth: true,
  },
};

export const tab: Tab = {
  label: route.meta.title,
  icon: 'description-o',
  to: {
    name: route.name,
  },
};
